// eventCenter 
// 主应用 --- 事件
export const MASTER_LOCALE_DATA_LOADED = 'master:locale:data:loaded';
export const MASTER_LOCALE_CHANGED = 'master:locale:changed';
// 子应用
export const MICRO_LOCALE_CHANGED = 'micro:locale:changed'
export const MICRO_LOCALE_DATA_REQUEST = 'micro:locale:data:request';


// 如果需要根据模块名称动态生成事件名称，可以定义一个函数
export const getEventNameForLoadModuleDataFromMaster = (moduleName: string) => `master:locale:module:${moduleName}:data:loaded`;